// Filing-only orders: the client files iXBRL accounts they already have. Nothing is tagged and no tagging is charged;
// we validate the file, a person reviews it, and only then can it be filed. UK only for now.
// Kept out of the region config for the same reason as taxComputation.js: the existing regions' configuration stays as it was.
import { orderedServiceIds } from './taxComputation';

export const OWN_IXBRL_ID = 'own_ixbrl';
// What the server prices a company by when it has no account type: worth nothing, so only the filing fees are charged.
export const OWN_IXBRL_PRICING_TYPE = 'own_ixbrl';
export const FINISHED_IXBRL_CATEGORY = 'finished_ixbrl';
export const FINISHED_IXBRL_ACCEPT = '.xhtml,.html,.htm';

export const OWN_IXBRL_SERVICE = {
  id: OWN_IXBRL_ID,
  title: 'Your own iXBRL (no tagging)',
  description: 'File iXBRL accounts you already have. We check the file and a reviewer approves it before it is filed.',
  price: 0,
};

const REGIONS_OFFERING_OWN_IXBRL = new Set(['UK']);

export const offersOwnIxbrl = (regionCode) => REGIONS_OFFERING_OWN_IXBRL.has(regionCode);

export const ordersOwnIxbrl = (wizardData) => orderedServiceIds(wizardData).includes(OWN_IXBRL_ID);

// A company in an own-iXBRL order has no account type and costs nothing for tagging.
export const isUntaggedOwnIxbrl = (wizardData, company) => ordersOwnIxbrl(wizardData) && !company?.accountType;

// The catalogue the order summaries price from, with the own-iXBRL marker added where it is offered.
export const withOwnIxbrl = (catalogue, regionCode) =>
  offersOwnIxbrl(regionCode) ? { ...catalogue, [OWN_IXBRL_ID]: OWN_IXBRL_SERVICE } : catalogue;
